// extracted by mini-css-extract-plugin
module.exports = {"body":"Explain_body__2wAM3","header":"Explain_header__zcJNF","gobackImgBox":"Explain_gobackImgBox__Ztxq2","goWrite":"Explain_goWrite__3el8P"};